// extracted by mini-css-extract-plugin
export default {"closeWrapper":"CloseWrapper_closeWrapper__HJ20E","noneWrapper":"CloseWrapper_noneWrapper__MBQY6"};